import { configureStore } from "@reduxjs/toolkit";
import listenerMiddleware from "@/redux/listener/listenerMiddleware";
import { reviewTrustPilotReducer } from "@/redux/slice/ReviewTrustPilotSlice";

const store = configureStore({
  reducer: {
    reviewTrustPilotReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
